import { useState } from "react";
import { Typography, Button, Input, InputAdornment } from "@mui/material";
import { tss } from "tss-react";
import { Scrollbars } from "react-custom-scrollbars";
import { FilterList, ArrowForward, ArrowBack, ArrowDropUp, ArrowDropDown, Info } from "@mui/icons-material";
import { useStyles as InfoStyles } from "./Info";
import { PanelHeader } from "components";
import commonStyles, { backgroundColor } from "styles/common";

const useStyles = tss.create({
    root: {
        position: "fixed",
        display: "table",
        background: backgroundColor,
        borderRadius: 5,
        width: 328,
        height: 560,
        top: 110,
        maxHeight: "calc(100vh - 227px)",
        userSelect: "none",
    },
    content: {
        backgroundColor: backgroundColor,
    },
    icon: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: 36,
        marginLeft: 10,
        color: "orange",
    },
    buttonIcon: {
        position: "relative",
        width: 16,
        height: 16,
        color: "#3D4F61",
        backgroundSize: "16px 16px",
        verticalAlign: "middle",
        display: "inline-block",
    },
    column: {
        width: 164,
        height: 300,
    },
    label: {
        color: "#3D4F61",
        fontSize: 12,
        letterSpacing: "0.4px",
        lineHeight: "14px",
        textAlign: "center",
    },
    frame: {
        height: 150,
        width: 382,
    },
    button: {
        width: 24,
        height: 24,
        minWidth: 24,
        marginRight: 8,
    },
    firstRow: {
        boxSizing: "border-box",
        height: 24,
        width: 150,
        border: "1px solid rgba(40,60,80,0.2)",
        borderRadius: "4px 4px 0 0",
        textAlign: "center",
    },
    secondRow: {
        boxSizing: "border-box",
        height: 336,
        width: 150,
        borderLeft: "1px solid rgba(40,60,80,0.2)",
        borderRight: "1px solid rgba(40,60,80,0.2)",
    },
    lastRow: {
        boxSizing: "border-box",
        height: 24,
        width: 150,
        border: "1px solid rgba(40,60,80,0.2)",
        transform: "scaleY(-1)",
        borderRadius: "4px 4px 0 0",
        textAlign: "center",
    },
    applyButton: {
        marginBottom: 0,
        textAlign: "right",
        marginRight: 9,
    },
    row: {
        position: "relative",
        height: 32,
        width: "95%",
        display: "inline-flex",
        alignItems: "center",
        paddingLeft: 8,
        color: "#283C50",
        fontSize: 16,
        letterSpacing: "0.15px",
        lineHeight: "18px",
    },
    selected: {
        backgroundColor: "rgba(0,39,118,0.1)",
        color: "#002776",
        fontSize: 16,
        letterSpacing: "0.15px",
        lineHeight: "18px",
    },
});

type IConfigure = {
    layer: any;
    selectedAttributes: any;
    defaultAttributes: any;
    filter: any;
    setFilter: any;
    closeWindow: () => void;
    updateParent: () => void;
    commentShowing?: boolean;
};

export default function ConfigureAttributes(props: IConfigure) {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const { classes: info } = InfoStyles();
    console.log("props:", props);
    const {
        layer,
        selectedAttributes,
        defaultAttributes,
        filter,
        setFilter,
        closeWindow,
        updateParent,
        commentShowing,
    } = props;

    const currentList = filter;
    const [available, setAvailable] = useState(defaultAttributes.filter((n: string) => !filter.includes(n)));
    const [selectedAvailable, setSelectedAvailable] = useState([]);
    console.log("currentList:", currentList);
    const searchAttributes = (e: any) => {
        const value = e.target.value;
        if (value !== "") {
            var filteredAttributes: any = currentList.filter(
                (attribute: string) =>
                    attribute.toLowerCase().substr(0, e.target.value.length) === e.target.value.toLowerCase() ||
                    attribute.toLowerCase().includes(e.target.value)
            );
            setFilter(filteredAttributes);
            var availabledAttributes: any = available.filter(
                (attribute: string) =>
                    attribute.toLowerCase().substr(0, e.target.value.length) === e.target.value.toLowerCase() ||
                    attribute.toLowerCase().includes(e.target.value)
            );
            setSelectedAvailable(availabledAttributes);
        } else {
            setFilter([]);
            setSelectedAvailable([]);
        }
    };
    const makeSelection = (evt: any, type: string) => {
        var name: string = evt.target.innerHTML;
        var curSelected: any;
        if (type === "selected") {
            curSelected = [...selectedAttributes];
            if (curSelected.includes(name)) {
                curSelected.splice(curSelected.indexOf(name), 1);
            } else {
                curSelected.push(name);
            }
            setFilter(curSelected);
        } else {
            curSelected = [...selectedAvailable];
            if (curSelected.includes(name)) {
                curSelected.splice(curSelected.indexOf(name), 1);
            } else {
                curSelected.push(name);
            }
            setSelectedAvailable(curSelected);
        }
    };
    const addToSelection = () => {
        var curList: any = [...currentList];
        var curSelected: any = [...available];
        var curAvailable: any = [...selectedAvailable];
        if (curSelected.includes(curAvailable)) {
            return;
        }
        for (var idx in curAvailable) {
            var name = curAvailable[idx];
            curSelected.splice(curSelected.indexOf(name), 1);
            if (!curList.includes(name)) {
                curList.push(name);
            }
        }
        curList = curList.filter((name: string) => name !== "");
        setFilter(curList);
        setAvailable(curSelected);
        setSelectedAvailable([]);
    };
    const removeFromSelection = () => {
        var curList: any = [...currentList];
        var curSelected: any = [...filter];
        var curAvailable: any = [...available];
        if (curAvailable.includes(curSelected)) {
            return;
        }
        curAvailable = curAvailable.concat(curSelected);
        for (var idx in curSelected) {
            var name = curSelected[idx];
            curList.splice(curList.indexOf(name), 1);
        }
        curList = curList.filter((name: string) => name !== "");
        setFilter(curList);
        setAvailable(curAvailable);
        setFilter([]);
    };
    const removeAll = () => {
        var curAvailable: any = [...available];
        curAvailable = curAvailable.concat(currentList);
        setFilter([]);
        setAvailable(curAvailable);
    };
    const selectionUp = () => {
        var curList: any = [...currentList];
        var curSelected: any = [...filter];
        var indexes: any = [];
        for (var idx in curSelected) {
            var name = curSelected[idx];
            var index = curList.indexOf(name);
            indexes.push(index);
        }
        indexes = indexes.sort();
        indexes.forEach((index: number) => {
            if (index !== 0) {
                curList.splice(index - 1, 0, curList.splice(index, 1)[0]);
            }
        });
        curList = curList.filter((name: string) => name !== "");
        setFilter(curList);
    };
    const selectionDown = () => {
        var curList: any = [...currentList];
        var curSelected: any = [...filter];
        var indexes: any = [];
        for (var idx in curSelected) {
            var name = curSelected[idx];
            var index = curList.indexOf(name);
            indexes.push(index);
        }
        indexes = indexes.sort((a: number, b: number) => {
            //descending
            return b - a;
        });
        indexes.forEach((index: number) => {
            if (index < curList.length - 1) {
                curList.splice(index + 1, 0, curList.splice(index, 1)[0]);
            }
        });
        curList = curList.filter((name: string) => name !== "");
        setFilter(curList);
    };
    const applySettings = () => {
        layer["custom_attributes"] = currentList.join(" ");
        updateParent();
    };
    return (
        <div className={classes.root} style={{ right: commentShowing ? 582 : 281 }}>
            <PanelHeader
                icon={<Info className={classes.icon} />}
                title="Configure Attributes"
                handleClose={closeWindow}
            />
            <div className={info.layerInfo} style={{ width: "100%", backgroundColor: backgroundColor }}>
                <Input
                    placeholder="Filter Attributes"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        paddingLeft: 9,
                    }}
                    onChange={searchAttributes}
                    disableUnderline={true}
                    startAdornment={
                        <InputAdornment position="start">
                            <FilterList className={classes.icon} />
                        </InputAdornment>
                    }
                />
            </div>
            <div className={classes.content}>
                <table cellPadding={0} cellSpacing={0} style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                            <td style={{ width: 164, height: 40 }}>
                                <Typography className={classes.label} style={{ fontWeight: "bold" }}>
                                    Available Attributes
                                </Typography>
                            </td>
                            <td style={{ width: 164, height: 40 }}>
                                <Typography className={classes.label} style={{ fontWeight: "bold" }}>
                                    Selected Attributes
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <table cellPadding={0} cellSpacing={9} style={{ width: 309, height: 383 }}>
                                    <tbody>
                                        <tr>
                                            <td className={classes.frame} valign="top">
                                                <div className={classes.firstRow}>
                                                    <Button className={classes.button} onClick={addToSelection}>
                                                        <ArrowForward className={info.icon} />
                                                    </Button>
                                                </div>
                                                <div className={classes.secondRow}>
                                                    <Scrollbars
                                                        autoHeight
                                                        autoHeightMax={336}
                                                        style={{
                                                            overflowX: "hidden",
                                                            userSelect: "none",
                                                        }}
                                                    >
                                                        {available.map((name: string, index: number) => (
                                                            <div
                                                                key={"available_" + index}
                                                                className={
                                                                    selectedAvailable.find(
                                                                        (availableName: string) =>
                                                                            availableName === name
                                                                    )
                                                                        ? cx(classes.row, classes.selected)
                                                                        : classes.row
                                                                }
                                                            >
                                                                <Typography
                                                                    className={common.label}
                                                                    noWrap
                                                                    onClick={(e) => makeSelection(e, "available")}
                                                                >
                                                                    {name}
                                                                </Typography>
                                                            </div>
                                                        ))}
                                                    </Scrollbars>
                                                </div>
                                                <div className={classes.lastRow}>
                                                    <Button className={classes.button} onClick={addToSelection}>
                                                        <ArrowForward className={classes.buttonIcon} />
                                                    </Button>
                                                </div>
                                            </td>
                                            <td className={classes.frame} valign="top">
                                                <div className={classes.firstRow}>
                                                    <Button
                                                        className={classes.button}
                                                        onClick={(e) => removeFromSelection()}
                                                    >
                                                        <ArrowBack className={classes.buttonIcon} />
                                                    </Button>
                                                    <Button className={classes.button} onClick={removeAll}>
                                                        <ArrowBack className={classes.buttonIcon} />
                                                        <ArrowBack className={classes.buttonIcon} />
                                                    </Button>
                                                    <Button className={classes.button} onClick={selectionUp}>
                                                        <ArrowDropUp className={classes.icon} />
                                                    </Button>
                                                    <Button className={classes.button} onClick={selectionDown}>
                                                        <ArrowDropDown className={classes.icon} />
                                                    </Button>
                                                </div>
                                                <div className={classes.secondRow}>
                                                    <Scrollbars
                                                        autoHeight
                                                        autoHeightMax={336}
                                                        style={{
                                                            overflowX: "hidden",
                                                        }}
                                                    >
                                                        {currentList.map((name: string) => (
                                                            <div
                                                                key={"selected_" + name}
                                                                className={
                                                                    filter.find(
                                                                        (availableName: string) =>
                                                                            availableName === name
                                                                    )
                                                                        ? cx(classes.row, classes.selected)
                                                                        : classes.row
                                                                }
                                                                onClick={(e) => makeSelection(e, "selected")}
                                                            >
                                                                <Typography className={common.label} noWrap>
                                                                    {name}
                                                                </Typography>
                                                            </div>
                                                        ))}
                                                    </Scrollbars>
                                                </div>
                                                <div className={classes.lastRow}>
                                                    <Button
                                                        className={classes.button}
                                                        onClick={(e) => removeFromSelection()}
                                                    >
                                                        <ArrowBack className={classes.buttonIcon} />
                                                    </Button>
                                                    <Button className={classes.button} onClick={removeAll}>
                                                        <ArrowBack className={classes.buttonIcon} />
                                                        <ArrowBack className={classes.buttonIcon} />
                                                    </Button>
                                                    <Button className={classes.button} onClick={selectionUp}>
                                                        <ArrowDropUp className={classes.icon} />
                                                    </Button>
                                                    <Button className={classes.button} onClick={selectionDown}>
                                                        <ArrowDropDown className={classes.icon} />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className={classes.applyButton}>
                    <Button
                        color="primary"
                        onClick={applySettings}
                        title="This panel contains changes that were not applied to the viewer. Click this button to update the view."
                    >
                        Apply
                    </Button>
                </div>
            </div>
        </div>
    );
}
